import icon from 'vue-svgicon';

icon.register({
    'regular/human-resources-employee-previous': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M13.5 21.75A9.75 9.75 0 1 0 3.75 12v.75" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="1" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M.75 9.75l3 3 3-3M18.48 17.25a6.636 6.636 0 0 0-9.96 0"/><circle pid="2" cx="13.5" cy="10.5" r="3.75" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
